exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-name[data-v-7c68d744]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.user-name img[data-v-7c68d744]{width:24px;height:24px;border-radius:50%}.user-name span[data-v-7c68d744]{padding-left:10px}\n", ""]);

// exports
